import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { langOption, langOptions } from './models/lang-options';
import { profileOptionsADMIN } from './models/profile-options';
import { TranslationService } from 'src/app/core/countries-managment/i18n/translation.service';
import { ExternalAuthService } from 'src/app/auth/external-auth.service';
import { TopbarContext, TopbarContextService } from '../services/topbar-context.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  profileButtons = [];
  languageSelector = langOptions;
  selectedLanguage: langOption = langOptions[1];
  userInfo;
  roleLabelKey = '';
  pageTitle = '';
  topbarContext: TopbarContext | null = null;
  private routerSub: Subscription;
  private contextSub: Subscription;

  private readonly roleLabels: Record<string, string> = {
    admin: 'USER_MENU.ROLE_ADMIN',
    sign: 'USER_MENU.ROLE_SIGN',
    edit: 'USER_MENU.ROLE_EDIT',
    read: 'USER_MENU.ROLE_READ',
    client: 'USER_MENU.ROLE_CLIENT',
    it: 'USER_MENU.ROLE_IT',
    logs: 'USER_MENU.ROLE_LOGS',
  };

  private readonly pageTitleKeys: Record<string, string> = {
    '/companies': 'TITLES.COMPANIES',
    '/individuals': 'MENU.PERSONS',
    '/map': 'MENU.CORPOTATE_MAP',
    '/library': 'MENU.LIBRARY',
    '/contracts/counterparties': 'COUNTERPARTIES.TITLE',
    '/contracts': 'MENU.CONTRACTS',
    '/expirations': 'MENU.EXPIRATIONS',
    '/administration': 'MENU.ADMINISTRATION',
    '/information': 'MENU.SHAREINFO',
    '/users': 'USER_MENU.USERS_SETTINGS',
    '/logs': 'USER_MENU.LOG_ACCESS',
    '/create': 'MENU.ADD',
    '/document': 'MENU.DOCUMENTS',
    '/docs': 'MENU.DOCUMENTS',
  };

  constructor(
    private router: Router,
    private translate: TranslateService,
    private translationService: TranslationService,
    private auth: ExternalAuthService,
    private topbarContextService: TopbarContextService
  ) {}

  ngOnInit(): void {
    this.userInfo = this.auth.getCurrentUserInfo();
    const user = this.auth.getCurrentUser();

    const role = typeof this.userInfo?.role === 'string'
      ? this.userInfo.role
      : this.userInfo?.role?.[0];
    this.roleLabelKey = role ? (this.roleLabels[role] || '') : '';

    if (typeof this.userInfo?.role === 'string') {
      if (this.userInfo.role === 'admin') {
        if (!this.userInfo?.enableSwitchFIRM) {
          this.profileButtons = profileOptionsADMIN.filter(e => e.key !== 'firm');
        } else {
          this.profileButtons = profileOptionsADMIN;
        }
      } else if (this.userInfo?.role === 'sign') {
        this.profileButtons = [];
      }
    } else {
      if (this.userInfo?.role?.find(e => e === 'admin')) {
        if (!this.userInfo?.enableSwitchFIRM) {
          this.profileButtons = profileOptionsADMIN.filter(e => e.key !== 'firm');
        } else {
          this.profileButtons = profileOptionsADMIN;
        }
      }
      if (this.userInfo?.role?.find(e => e === 'sign')) {
        this.profileButtons = [];
      }
    }

    if (user.has_groups) {
      this.profileButtons = this.profileButtons.filter(
        e => e.key !== 'users' && e.key !== 'logs'
      );
    }

    let storageLang = this.translationService.getSelectedLanguage();
    let storageSelectedLang = this.languageSelector.find(e => e.lang === storageLang);
    this.setLenguageBycountryCode(storageSelectedLang ? storageSelectedLang : langOptions[1]);

    // Page title from URL
    this.updatePageTitle(this.router.url);
    this.routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects || event.url)
    ).subscribe(url => this.updatePageTitle(url));

    // Listen for custom topbar context
    this.contextSub = this.topbarContextService.context$.subscribe(
      ctx => this.topbarContext = ctx
    );
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.contextSub?.unsubscribe();
  }

  setLenguageBycountryCode(lang: langOption) {
    this.translationService.setDefaultLanguage(lang.lang);
    this.translationService.setLanguage(lang.lang);
    this.selectedLanguage = lang;
    this.updatePageTitle(this.router.url);
  }

  onClickMenu(key: string) {
    switch (key) {
      case 'users':
      case 'logs':
        this.router.navigate([key]);
        break;
      case 'portal':
        this.auth.goToPortal();
        break;
      case 'firm':
        this.auth.switchFirm();
        break;
    }
  }

  logOut() {
    this.auth.logout(8);
  }

  private updatePageTitle(url: string): void {
    const match = Object.keys(this.pageTitleKeys).find(path => url.startsWith(path));
    this.pageTitle = match ? this.translate.instant(this.pageTitleKeys[match]) : '';
  }
}
